
import DaisoResizedImage from './DaisoResizedImage.vue'
import DaisoStaticImage from './DaisoStaticImage.vue'

export default {
  name: 'DaisoImage',
  components: {
    DaisoResizedImage,
    DaisoStaticImage
  },
  inheritAttrs: false,
  props: {
    isStaticImage: {
      type: Boolean,
      default: false
    }
  }
}
